import * as React from "react";
import type { SVGProps } from "react";

export const SvgGameDeadlockGrey = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 16 16" {...props}>
    <mask id="game-deadlock-grey_a" maskUnits="userSpaceOnUse" x={0} y={0} width={16} height={16}>
      <rect width={16} height={16} fill="#fff" />
      <path d="M9.8,8c0,1-.8,1.8-1.8,1.8s-1.8-.8-1.8-1.8.8-1.8,1.8-1.8,1.8.8,1.8,1.8Z" fill="#000" />
    </mask>
    <circle cx={8} cy={8} r={6.75} stroke="currentColor" strokeWidth={0.9} />
    <path d="M1.3 8h13.4M8 1.3v13.4M3.26 3.26l9.48 9.48M12.74 3.26 3.26 12.74" stroke="currentColor" strokeWidth={0.45} />
    <path
      d="M3.6,8l2.6-1.8c.8-.5,2.3-.9,3.7,0,.6.4,1.1.7,1.5,1,.5.4,1,.7,1.1.8H3.6ZM3.6,8l2.6,1.8c.8.5,2.3.9,3.7,0,.6-.4,1.1-.7,1.5-1,.5-.4,1-.7,1.1-.8H3.6Z"
      fill="currentColor"
      fillRule="evenodd"
      mask="url(#game-deadlock-grey_a)"
    />
    <path d="M9,8c0,.6-.5,1-1,1s-1-.5-1-1,.5-1,1-1,1,.5,1,1Z" fill="currentColor" />
  </svg>
);
